(() => {
  'use strict';
  const config = window.Rosumie || {};
  const root = config.root || '/';
  const money = value => new Intl.NumberFormat(config.locale || 'fr', {style:'currency',currency:config.currency || 'EUR'}).format(value / 100);
  const qs = (selector, scope = document) => scope.querySelector(selector);
  const qsa = (selector, scope = document) => [...scope.querySelectorAll(selector)];
  let previousFocus;
  let cartBusy = false;
  const showMessage = message => {
    const toast = qs('[data-toast]');
    if (!toast) return;
    toast.textContent = message;
    toast.classList.add('is-visible');
    clearTimeout(showMessage.timer);
    showMessage.timer = setTimeout(() => toast.classList.remove('is-visible'), 5000);
  };
  function openCart() {
    const drawer = qs('#CartDrawer');
    if (!drawer || typeof drawer.showModal !== 'function') { window.location.assign(config.cartUrl || root + 'cart'); return; }
    previousFocus = document.activeElement;
    if (!drawer.open) drawer.showModal();
    document.body.style.overflow = 'hidden';
  }
  function closeCart() {
    const drawer = qs('#CartDrawer');
    if (drawer && drawer.open) drawer.close();
    document.body.style.overflow = '';
    if (previousFocus && previousFocus.isConnected) previousFocus.focus();
  }
  function bindDrawer() {
    const drawer = qs('#CartDrawer');
    if (!drawer || drawer.dataset.bound) return;
    drawer.dataset.bound = 'true';
    drawer.addEventListener('close', () => { document.body.style.overflow = ''; });
    drawer.addEventListener('click', event => {
      if (event.target === drawer) {
        const box = drawer.getBoundingClientRect();
        if (event.clientX < box.left || event.clientX > box.right) closeCart();
      }
    });
  }
  async function refreshCart(sections) {
    let markup = sections && sections['cart-drawer'];
    if (!markup) {
      const response = await fetch(root + '?section_id=cart-drawer', {credentials:'same-origin'});
      if (!response.ok) throw new Error('Le panier a été mis à jour. Rechargez la page pour le consulter.');
      markup = await response.text();
    }
    const parsed = new DOMParser().parseFromString(markup, 'text/html');
    const fresh = qs('#shopify-section-cart-drawer', parsed);
    const current = qs('#shopify-section-cart-drawer');
    if (!fresh || !current) throw new Error('Votre panier a été mis à jour. Ouvrez la page panier pour continuer.');
    const wasOpen = Boolean(qs('#CartDrawer')?.open);
    if (wasOpen) qs('#CartDrawer').close();
    current.replaceWith(fresh);
    bindDrawer();
    const count = Number(qs('[data-drawer-count]')?.dataset.drawerCount || 0);
    qsa('[data-cart-count]').forEach(el => { el.textContent = String(count); el.hidden = count === 0; });
    if (wasOpen) openCart();
    document.dispatchEvent(new CustomEvent('cart:updated', {detail:{item_count:count}}));
  }
  function initProducts(scope = document) {
    qsa('[data-product-section]', scope).forEach(section => {
      if (section.dataset.initialized) return;
      section.dataset.initialized = 'true';
      const gallery = qs('[data-gallery]', section);
      let index = 0;
      const slides = qsa('[data-slide]', gallery || section);
      function go(next) {
        if (!slides.length) return;
        index = (next + slides.length) % slides.length;
        slides.forEach((slide, i) => {
          slide.hidden = i !== index;
          if (i !== index) qsa('video',slide).forEach(video=>video.pause());
        });
        qsa('[data-gallery-go]', gallery).forEach(button => button.setAttribute('aria-pressed', String(Number(button.dataset.galleryGo) === index)));
        const counter = qs('[data-gallery-counter]', gallery);
        if (counter) counter.textContent = `${index + 1} / ${slides.length}`;
      }
      if (gallery) {
        gallery.addEventListener('click', event => {
          const step = event.target.closest('[data-gallery-step]');
          const thumb = event.target.closest('[data-gallery-go]');
          if (step) go(index + Number(step.dataset.galleryStep));
          if (thumb) go(Number(thumb.dataset.galleryGo));
        });
        qs('.gallery-stage',gallery)?.addEventListener('keydown', event=>{
          if(event.key === 'ArrowRight'){event.preventDefault();go(index+1);}
          if(event.key === 'ArrowLeft'){event.preventDefault();go(index-1);}
        });
        go(0);
      }
      const form = qs('[data-rosy-form]', section);
      if (!form) return;
      function selectVariant(input, updateUrl) {
        if (!input) return;
        const price = qs('[data-product-price]', section);
        if (price) price.textContent = money(Number(input.dataset.price));
        const button = qs('[name=add]', form);
        const available = input.dataset.available === 'true';
        button.disabled = !available;
        qs('[data-add-label]', button).textContent = available ? 'Ajouter au panier' : 'Épuisé';
        if (updateUrl && window.location.pathname.includes('/products/')) {
          const url = new URL(window.location.href);url.searchParams.set('variant',input.value);window.history.replaceState({},'',url);
        }
        if (updateUrl && gallery) {
          const realSlide = slides.findIndex(slide=>slide.dataset.mediaId && slide.dataset.mediaId === input.dataset.media);
          if (realSlide >= 0) go(realSlide);
          else if (!slides.some(slide=>slide.dataset.mediaId)) {
            const units = Number(input.dataset.units);
            if (units === 4) go(5);else if (units === 2) go(4);else go(3);
          }
        }
        document.dispatchEvent(new CustomEvent('variant:change',{detail:{variantId:input.value}}));
      }
      form.addEventListener('change', event=>{if(event.target.matches('input[name=id]'))selectVariant(event.target,true);});
      selectVariant(qs('input[name=id]:checked',form),false);
      form.addEventListener('submit', async event => {
        const submitter = event.submitter;
        if (submitter && submitter.name !== 'add') return;
        event.preventDefault();
        const variant = qs('input[name=id]:checked',form);
        if (!variant || variant.disabled) return;
        const error = qs('[data-form-error]',form);
        const button = qs('[name=add]',form);
        error.hidden=true;button.disabled=true;button.setAttribute('aria-busy','true');
        qs('[data-add-label]',button).textContent='Ajout en cours…';
        let added = false;
        try {
          const body=new FormData(form);body.set('sections','cart-drawer');body.set('sections_url',window.location.pathname);
          const response=await fetch((config.addUrl || root+'cart/add')+'.js',{method:'POST',headers:{Accept:'application/json'},body,credentials:'same-origin'});
          const result=await response.json();
          if (!response.ok) throw new Error(result.description || result.message || 'Cet article ne peut pas être ajouté pour le moment.');
          added=true;
          await refreshCart(result.sections);
          openCart();
        } catch (failure) {
          if(added){window.location.assign(config.cartUrl || root+'cart');return;}
          error.textContent=failure.message || 'Une erreur est survenue. Réessayez.';error.hidden=false;
        } finally {button.removeAttribute('aria-busy');selectVariant(variant,false);}
      });
    });
  }
  document.addEventListener('click', async event => {
    const opener=event.target.closest('[data-open-cart]');
    if(opener && !event.ctrlKey && !event.metaKey && !event.shiftKey){event.preventDefault();openCart();return;}
    if(event.target.closest('[data-close-cart]')){closeCart();return;}
    if(event.target.closest('[data-close-cart-link]')){closeCart();return;}
    const change=event.target.closest('[data-cart-key]');
    if(change){
      event.preventDefault();if(cartBusy)return;cartBusy=true;
      const controls=qsa('[data-cart-key]');controls.forEach(button=>button.disabled=true);
      const error=qs('[data-cart-error]');if(error)error.hidden=true;
      try{
        const response=await fetch((config.changeUrl || root+'cart/change')+'.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({id:change.dataset.cartKey,quantity:Number(change.dataset.cartQuantity),sections:['cart-drawer'],sections_url:window.location.pathname})});
        const result=await response.json();if(!response.ok)throw new Error(result.description || result.message || 'Impossible de modifier cette quantité.');
        await refreshCart(result.sections);
      }catch(failure){const target=qs('[data-cart-error]');if(target){target.textContent=failure.message;target.hidden=false;}else showMessage(failure.message);}
      finally{cartBusy=false;qsa('[data-cart-key]').forEach(button=>button.disabled=false);}
    }
    const navLink=event.target.closest('.mobile-menu nav a');if(navLink){const menu=navLink.closest('details');menu.open=false;}
  });
  document.addEventListener('shopify:section:load',event=>{initProducts(event.target);bindDrawer();});
  initProducts();bindDrawer();
})();
